import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Modal as MuiModal, Box, IconButton, Typography } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const Modal = props => {
  const { children, onClose, className, header, label, closeButton } = props;
  const classes = useStyles();

  return (
    <MuiModal className={classes.modal} open onClose={onClose} disableBackdropClick>
      <Box className={classes.paper}>
        {header && (
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Typography variant="h1">{label}</Typography>
            <IconButton className={clsx(classes.closeButton, { [classes.hidden]: !closeButton })} onClick={onClose}>
              <Icon name="close" />
            </IconButton>
          </Box>
        )}
        <Box className={className}>{children}</Box>
      </Box>
    </MuiModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  header: PropTypes.bool,
  label: PropTypes.string,
  closeButton: PropTypes.bool,
};

Modal.defaultProps = {
  className: '',
  header: false,
  label: '',
  closeButton: false,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/sharedComponents/Modal/Modal.js